/* eslint-disable no-undef */
import React, { createContext, useCallback, useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import { cloneDeep } from 'lodash';

export const AgentContext = createContext();

const agentInitialContext = {
	identifier: 'allianz',
	PA: window?.__CLIENT_ENV?.CLIENT_ENV_DEFAULT_PA ?? 'PA489861',
	AGENT_CODE: window?.__CLIENT_ENV?.CLIENT_ENV_DEFAULT_CODE ?? 'DEFAULT',
	delioEnabled: true,
	delioOrigen: 'coinscrapfinance',
	delioPhone: CONFIG.contactPhone.value,
	delioPhoneText: CONFIG.contactPhone.label,
};

const AgentProvider = ({ children }) => {
	const initialContext = cloneDeep(agentInitialContext);

	const setAgentValues = (key, value) => {
		setAgent((prevState) => {
			const data = { ...prevState };
			data.agent[key] = value;
			return data;
		});
		localStorage.setItem(`allianz-agent-${key}`, value);
	};

	const setInitialValues = useCallback(() => {
		setAgentValues('identifier', 'allianz');
		setAgentValues('PA', window?.__CLIENT_ENV?.CLIENT_ENV_DEFAULT_PA ?? 'PA489861');
		setAgentValues(
			'AGENT_CODE',
			window?.__CLIENT_ENV?.CLIENT_ENV_DEFAULT_AGENT_CODE ?? 'DEFAULT',
		);
		setAgentValues('delioEnabled', true);
		setAgentValues('delioOrigen', 'coinscrapfinance');
		setAgentValues(
			'delioPhone',
			window?.__CLIENT_ENV?.CLIENT_ENV_DEFAULT_DELIO_PHONE ?? CONFIG.contactPhone.value,
		);
		setAgentValues(
			'delioPhoneText',
			window?.__CLIENT_ENV?.CLIENT_ENV_DEFAULT_DELIO_PHONE_TEXT ?? CONFIG.contactPhone.label,
		);
	}, []);

	const setBmwValues = useCallback(() => {
		setAgentValues('identifier', 'bmw');
		setAgentValues('PA', window?.__CLIENT_ENV?.CLIENT_ENV_BMW_PA ?? 'PA39632A');
		setAgentValues('AGENT_CODE', window?.__CLIENT_ENV?.CLIENT_ENV_BMW_AGENT_CODE ?? 'DEFAULT');
		setAgentValues('delioEnabled', false);
		setAgentValues('delioOrigen', 'coinscrapfinance');
		setAgentValues(
			'delioPhone',
			window?.__CLIENT_ENV?.CLIENT_ENV_BMW_DELIO_PHONE ?? CONFIG.contactPhone.value,
		);
		setAgentValues(
			'delioPhoneText',
			window?.__CLIENT_ENV?.CLIENT_ENV_BMW_DELIO_PHONE_TEXT ?? CONFIG.contactPhone.label,
		);
	}, []);

	const setRastreatorValues = useCallback(() => {
		setAgentValues('identifier', 'rastreator');
		setAgentValues('PA', window?.__CLIENT_ENV?.CLIENT_ENV_RASTREATOR_PA ?? 'PA39632A');
		setAgentValues(
			'AGENT_CODE',
			window?.__CLIENT_ENV?.CLIENT_ENV_RASTREATOR_AGENT_CODE ?? 'DEFAULT',
		);
		setAgentValues('delioEnabled', true);
		setAgentValues('delioOrigen', 'rastreator');
		setAgentValues(
			'delioPhone',
			window?.__CLIENT_ENV?.CLIENT_ENV_RASTREATOR_DELIO_PHONE ?? CONFIG.contactPhone.value,
		);
		setAgentValues(
			'delioPhoneText',
			window?.__CLIENT_ENV?.CLIENT_ENV_RASTREATOR_DELIO_PHONE_TEXT ??
				CONFIG.contactPhone.label,
		);
	}, []);

	const agentState = {
		agent: initialContext,
		setAgentValues,
		setInitialValues,
		setBmwValues,
		setRastreatorValues,
	};

	const [agent, setAgent] = useState(agentState);

	useEffect(() => {
		const identifier = localStorage.getItem('allianz-agent-identifier');

		if (identifier === 'bmw') {
			setBmwValues();
		} else if (identifier === 'rastreator') {
			setRastreatorValues();
		}

		return () => {};
	}, [setBmwValues, setRastreatorValues]);

	return <AgentContext.Provider value={agent}>{children}</AgentContext.Provider>;
};

export default AgentProvider;
